import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeInput as RaDateTimeInput } from 'react-admin';
import moment from 'moment';

export const formatDateTimeLocal = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const m = moment(value);

    return m.isValid() ? m.format('YYYY-MM-DDTHH:mm') : '';
};

const parseDateTime = (value) => {
    if (!value) {
        return null;
    }

    const m = moment(value);

    return m.isValid() ? m.toISOString() : null;
};

const DateTimeInput = ({ format = formatDateTimeLocal, parse = parseDateTime, ...props }) => {
    return (
        <RaDateTimeInput
            format={format}
            parse={parse}
            {...props}
        />
    );
};

DateTimeInput.propTypes = {
    format: PropTypes.func,
    parse: PropTypes.func,
};

export default DateTimeInput;

